import { render, staticRenderFns } from "./CreateEventDialog.vue?vue&type=template&id=453c72de"
import script from "./CreateEventDialog.vue?vue&type=script&lang=ts"
export * from "./CreateEventDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports